import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'm-content-card',
  exportAs: 'mContentCard',
  template: `
    <div class="m-card-item">
      <div class="m-card-item-img-container">
        <div>
          <img [attr.alt]="'background'" [src]="mBackground" />
          <div *ngIf="!mHaveIcon" class="m-card-img-alt">{{ mShortTitle }}</div>
        </div>
        <div class="m-card-item-mask">
          <div class="m-card-item-mask-operation-collect" *ngIf="mStarEnable">
            <i
              nz-icon
              nzType="star"
              class="m-card-star-common"
              [nzTheme]="mStar ? 'fill' : 'outline'"
              [class.m-card-star]="mStar"
              (click)="onStar()"
            ></i>
          </div>
          <div class="m-card-operation-btn">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
      <div class="m-card-item-info">
        <div class="m-card-info-top">
          <img *ngIf="mHot" alt="hot" [attr.src]="mHotBtnIcon" />
          <span nz-tooltip [nzTooltipTitle]="mTitle.length > 10 ? mTitle : null">
            {{ mTitle }}
          </span>
        </div>
        <div class="m-card-info-bottom">
          <p nz-tooltip [nzTooltipTitle]="mDesc.length > 10 ? mDesc : null">{{ mDesc }}</p>
        </div>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MContentCardComponent {
  @Input() mTitle = ''; // 标题
  @Input() mHaveIcon = false; // 是否有特定的卡片的icon
  @Input() mDesc = ''; // 描述
  @Input() mBackground = ''; // 背景图片
  @Input() mHotBtnIcon = ''; // 热门收藏 icon
  @Input() mHot = true; // 热门
  @Input() mStar = false; // 收藏
  @Input() mStarEnable = true; // 允许收藏

  @Output() readonly mStarChange = new EventEmitter<boolean>();

  // 显示默认empty图片时,展示的缩略版标题
  get mShortTitle(): string {
    return this.mTitle.substr(0, 2);
  }

  onStar(): void {
    this.mStar = !this.mStar;
    this.mStarChange.emit(this.mStar);
  }
}
